// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class SearchPromotionsCarousel extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector(
      '[data-el="search-promotions-carousel.slides"]'
    )
    this.slideEls = this.querySelectorAll(
      '[data-el="search-promotions-carousel.slide"]'
    )

    this.progressEl = this.querySelector(
      '[data-el="search-promotions-carousel.progress"]'
    )
    this.arrowNextEls = this.querySelectorAll(
      '[data-el="search-promotions-carousel.controlnext"]'
    )
    this.arrowPrevEls = this.querySelectorAll(
      '[data-el="search-promotions-carousel.controlprevious"]'
    )

    if (this.slideEls.length < 2) return

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.SEARCH_TAB.OPENED,
      () => {
        this.carousel = this.initialiseCarousel()
      }
    )

    this.arrowNextEls.forEach(arrowNextEl => {
      arrowNextEl.addEventListener('click', this.changeCarousel.bind(this))
    })
    this.arrowPrevEls.forEach(arrowPrevEl => {
      arrowPrevEl.addEventListener('click', this.changeCarousel.bind(this))
    })
  }

  initialiseCarousel () {
    return new KeenSlider(this.slidesEl, {
      duration: 2500,
      loop: false,
      mode: 'snap',
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.25,
      spacing: 5,
      breakpoints: {
        '(min-width: 768px)': {
          loop: false,
          mode: 'snap',
          spacing: 5,
          slidesPerView: 1.5,
        },
        '(min-width: 900px)': {
          loop: false,
          mode: 'snap',
          spacing: 12,
          slidesPerView: 3,
        },
      },
      move: instance => {
        this.slideEls.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide
          )
        })
        if (this.progressEl) {
          const progressTrack = instance.details().progressTrack
          const progressAmount = progressTrack >= 1 ? 1 : progressTrack
          const movementPercentage = progressAmount * 100
          this.progressEl.style.setProperty(
            '--progress',
            `${movementPercentage}%`
          )
        }
      },
    })
  }

  changeCarousel (e) {
    if (e.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('search-promotions-carousel', SearchPromotionsCarousel)
